export default {
  visa: 'visa',
  'american express': 'amex',
  mastercard: 'master-card',
  discover: 'discover',
  jcb: 'jcb',
  'diners club': 'diner-club'
};
